var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75184 7.44933H2.44651C1.45717 7.44933 0.963172 7.44933 0.751838 7.12267C0.541172 6.79667 0.741839 6.34267 1.14384 5.434L2.35184 2.702C2.71717 1.876 2.89984 1.46267 3.25384 1.23133C3.60784 1 4.05717 1 4.95651 1H6.34984C7.44184 1 7.98851 1 8.19451 1.35667C8.40051 1.714 8.12917 2.19 7.58784 3.144L6.87251 4.40133C6.60317 4.87533 6.46851 5.112 6.47051 5.30667C6.47251 5.55867 6.60717 5.79067 6.82384 5.918C6.99051 6.016 7.26184 6.016 7.80451 6.016C8.49117 6.016 8.83451 6.016 9.01317 6.13467C9.24584 6.28933 9.36717 6.56533 9.32451 6.842C9.29184 7.05533 9.06117 7.31067 8.59917 7.82133L4.90917 11.9013C4.18451 12.7033 3.82251 13.104 3.57851 12.9767C3.33517 12.85 3.45184 12.3213 3.68517 11.264L4.14384 9.19333C4.32184 8.388 4.4105 7.98533 4.19717 7.71733C3.9825 7.44933 3.57251 7.44933 2.75184 7.44933Z",
    stroke: "#48BB78",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.230e10549c5f522c0866f5e851997810.svg";
export { ForwardRef as ReactComponent };